import { Inject, Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FhFormValidators } from '../object/fh-form-validators';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Injectable({
  providedIn: 'root'
})
export class FhFormGeneralProviderService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  setForm(form: FormGroup | FormArray, setup: any, stepName: string, isFormArray = false, prefix?: string) {
    const key = (stepName || '').toLowerCase();
    let fields: any;

    if (setup.formFieldsByStep) {
      fields = setup.formFieldsByStep?.[key] ?? [];
    } else {
      fields = setup.formFields;
    }

    if (!fields.length) return;

    if (prefix) {
      fields = fields.filter((field: any) => field.fieldName.startsWith(prefix));
    }

    const applyToGroup = (group: FormGroup) => {
      // Separar campos normais dos customFields
      const regularFields: any[] = [];
      const customFields: any[] = [];

      fields.forEach((field: any) => {
        if (field.fieldName.includes('.customFields.')) {
          customFields.push(field);
        } else {
          regularFields.push(field);
        }
      });

      // Processar campos normais
      regularFields.forEach((field: any) => {
        const name = field.fieldName.split('.').length > 1 ? field.fieldName.split('.')[1] : field.fieldName;
        const control = group.get(name);
        if (!control) return;

        if (!field.active) {
          group.removeControl(name);
          return;
        }

        if (field.isMandatory) {
          this.addRequiredValidator(control, name);
        }
      });

      // Processar customFields
      if (customFields.length > 0) {
        this.processCustomFields(group, customFields);
      }
    };

    if (isFormArray && form instanceof FormArray) {
      form.controls.forEach(control => {
        if (control instanceof FormGroup) {
          applyToGroup(control);
        }
      });
    } else if (form instanceof FormGroup) {
      applyToGroup(form);
    }
  }

  isFieldActive(setup: any, stepName: string, fieldName: string, prefix?: string): boolean {
    if (!setup) return true;

    const key = (stepName || '').toLowerCase();
    const fields: any[] = setup.formFieldsByStep ? setup.formFieldsByStep[key] ?? [] : setup.formFields ?? [];

    if (!fields.length) return true;

    const fullName = prefix ? `${prefix}.${fieldName}` : fieldName;
    const field = fields.find((f: any) => f.fieldName === fullName);

    return field ? field.active === true : true;
  }

  private processCustomFields(group: FormGroup, customFields: any[]) {
    let customFieldsArray = group.get('customFields') as FormArray;

    if (!customFieldsArray) {
      customFieldsArray = new FormArray<FormGroup>([]);
      group.addControl('customFields', customFieldsArray);
    }

    customFieldsArray.clear();

    customFields.forEach((field: any) => {
      if (!field.active) return;

      const parts = field.fieldName.split('.customFields.');
      const code = parts.length > 1 ? parts[1] : '';

      if (!code) return;

      const customFieldGroup = new FormGroup({
        code: new FormControl(code),
        value: new FormControl('')
      });

      if (field.isMandatory) {
        customFieldGroup.get('value')?.addValidators([
          FhFormValidators.required(`customFields.${code}`)
        ]);
      }

      customFieldsArray.push(customFieldGroup);
    });
  }

  private addRequiredValidator(control: any, name: string) {
    switch (name) {
      case 'bankingInfoName':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'paymentAccountHolder' : name)]);
        break;
      case 'bankingInfoNif':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'taxNumber' : name)]);
        break;
      case 'bankingInfoAddress':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'address' : name)]);
        break;
      case 'bankingInfoPostalCode':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'postalCode' : name)]);
        break;
      case 'bankingInfoCity':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'location' : name)]);
        break;
      case 'bankingInfoCountry':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'country' : name)]);
        break;
      case 'nif':
        control.addValidators([FhFormValidators.required(this.appConfig.apiPartnershipId == 'mps' ? 'nipc' : name)]);
        break;
      default:
        control.addValidators([FhFormValidators.required(name)]);
        break;
    }
  }
}